<template>
  <div>
    <div class="center">
      <div style="width: 440px; margin: 0 auto">
        <el-row :gutter="0">
          <el-col :span="19">
            <el-date-picker
              v-model="scheduleAt"
              type="daterange"
              style="width: 100%"
              range-separator="-"
              :start-placeholder="$t('text.startAt')"
              :end-placeholder="$t('text.endAt')"
              @change="selectScheduleAt"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" style="width: 100%" @click="submit">{{
              $t("action.searchMesSchedule")
            }}</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="wrapper table-area">
      <div class="noData" v-if="scheduleAt == null">
        {{ $t("rules.select", [$t("text.date")]) }}
      </div>
      <div v-else>
        <div v-if="scheduleAnalyses.length != 0">
          <div
            v-for="(scheduleAnalyse, index) of scheduleAnalyses"
            :key="index"
            class="mgb10"
          >
            <div style="height: 50px; line-height: 50px" @click="expend(index)">
              <span>
                <i
                  :class="
                    scheduleAnalyse.showDF == true
                      ? 'el-icon-arrow-down'
                      : 'el-icon-arrow-right'
                  "
                  style="font-size: 18px"
                  class="mgr10"
                />
              </span>
              <span class="font20 mgr10">{{ scheduleAnalyse.name }}</span>
              <span class="mgr10">
                <span class="mgr10">
                  {{ $t("factory.bulkCapacity") }}：{{
                    scheduleAnalyse.bulkCapacity
                  }}
                </span>
                <span class="mgr10">
                  {{ $t("factory.customCapacity") }}：{{
                    scheduleAnalyse.customCapacity
                  }}
                </span>
                <span class="mgr10">
                  {{ $t("factory.redundancyPercent") }}：{{
                    scheduleAnalyse.redundancyPercent
                  }}%
                </span>
              </span>
              <span v-if="scheduleAnalyse.nonWork != null" class="grey">
                <span
                  v-if="
                    computeHoliday(scheduleAnalyse.nonWork, 'yearHoliday')
                      .length != 0
                  "
                >
                  {{ $t("factory.yearHoliday") }}：{{
                    computeHoliday(scheduleAnalyse.nonWork, "yearHoliday").join(
                      ","
                    )
                  }}
                </span>
                <span
                  v-if="
                    computeHoliday(scheduleAnalyse.nonWork, 'monthHoliday')
                      .length != 0
                  "
                >
                  {{ $t("factory.monthHoliday") }}：{{
                    computeHoliday(
                      scheduleAnalyse.nonWork,
                      "monthHoliday"
                    ).join(",")
                  }}
                </span>
                <span
                  v-if="
                    computeHoliday(scheduleAnalyse.nonWork, 'weekHoliday')
                      .length != 0
                  "
                >
                  {{ $t("factory.weekHoliday") }}：{{
                    computeHoliday(scheduleAnalyse.nonWork, "weekHoliday").join(
                      ","
                    )
                  }}
                </span>
              </span>
            </div>
            <div v-if="scheduleAnalyse.showDF">
              <vxe-table
                :data="scheduleAnalyse.scheduleCapacityAnalyses"
                ref="recordsTable"
                class="recordsTable"
                size="mini"
                resizable
                round
                highlight-hover-row
                auto-resize
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column field="date" :title="$t('text.date')" />
                <vxe-table-column
                  field="bulkTotal"
                  :title="$t('factory.bulkTotal')"
                />
                <vxe-table-column
                  field="bulkUsed"
                  :title="$t('factory.bulkUsed')"
                />
                <vxe-table-column
                  field="bulkRemain"
                  :title="$t('factory.bulkRemain')"
                >
                  <template v-slot="{ row }">
                    <span :class="row.bulkRemain > 0 ? 'blue' : 'red'">{{
                      row.bulkRemain
                    }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="customTotal"
                  :title="$t('factory.customTotal')"
                />
                <vxe-table-column
                  field="customUsed"
                  :title="$t('factory.customUsed')"
                />
                <vxe-table-column
                  field="customRemain"
                  :title="$t('factory.customRemain')"
                >
                  <template v-slot="{ row }">
                    <span :class="row.customRemain > 0 ? 'blue' : 'red'">{{
                      row.customRemain
                    }}</span>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </div>
          </div>
        </div>
        <div v-else class="noData"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Util from "@/utils/index.js";
import WorkOrder from "@/api/workOrder.js";

export default {
  mixins: [page],
  components: {
    RawHtmlLimitNumber,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "半个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      scheduleAt: null,
      scheduleAnalyses: [],
    };
  },
  created() {
    const self = this;
  },
  methods: {
    expend(index) {
      this.scheduleAnalyses[index].showDF =
        !this.scheduleAnalyses[index].showDF;
    },
    selectScheduleAt() {
      this.scheduleAnalyses = [];
    },
    submit() {
      const self = this;
      if (self.scheduleAt == null) {
        self.$message({
          message: self.$t("rules.select", [$t("text.date")]),
          type: "warning",
        });
        return;
      }
      let obj = {
        scheduleAtStartAt: Util.formatDate(self.scheduleAt[0]) + " 00:00:00",
        scheduleAtEndAt: Util.formatDate(self.scheduleAt[1]) + " 23:59:59",
      };
      WorkOrder.scheduleAnalyse(obj).then(function (res) {
        if (res.status == 200) {
          self.scheduleAnalyses = res.data;
          for (const scheduleAnalyse of self.scheduleAnalyses) {
            Vue.set(scheduleAnalyse, "showDF", true);
          }
        } else {
          self.sysError();
        }
      });
    },
    computeHoliday(nonWork, type) {
      if (nonWork == null) {
        return [];
      }
      const nonWorkObj = JSON.parse(nonWork);
      if (type == "yearHoliday") {
        if (nonWorkObj.yearHoliday.open == true) {
          return nonWorkObj.yearHoliday.list;
        }
        return [];
      }
      if (type == "monthHoliday") {
        if (nonWorkObj.monthHoliday.open == true) {
          return nonWorkObj.monthHoliday.list;
        }
        return [];
      }
      if (type == "weekHoliday") {
        if (nonWorkObj.weekHoliday.open == true) {
          return nonWorkObj.weekHoliday.list;
        }
        return [];
      }
    },
    //
  },
};
</script>
<style scoped>
</style>
